<template>
    <div class="write-off-container">
        <el-card  class="mb16">
            <div class="orderManage-query">
                <div class="orderManage-query-input">
                    <div class="query-input-item">
                        <span class="input-item-label"> 订单号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入订单号" v-model="query.order_id" clearable></el-input>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 产品:</span>
                        <el-select v-model="query.product_code" placeholder="请选择产品" size="mini" class="mr20 query-select-shot" clearable>
                            <el-option v-for="item in options.productList" :key="item.id" :label="item.product_name" :value="item.product_code"></el-option>                      
                        </el-select>
                    </div> 
                    <div class="query-input-item" v-if="$PayNameImg == 'lianmei' || $PayNameImg == 'default'">
                        <span class="input-item-label"> 商户号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入商户号" v-model="query.business_no" clearable></el-input>                        
                    </div> 
                    <div class="query-input-item">
                        <span class="input-item-label"> 游戏账号:</span>
                        <el-input class="query-input" size="small" placeholder="请输入游戏账号" v-model="query.game_account" clearable></el-input>
                    </div>   
                </div>                
                <div class="orderManage-query-input">                         
                    <div class="query-input-item">
                        <span class="input-item-label"> 订单面值:</span>
                        <el-select v-model="query.denomination_value" placeholder="请选择面值" clearable size="mini" class="mr20">
                            <el-option v-for="item in options.faceValueList" :key="item.id" :label=" item.label " :value="item.value"></el-option>                           
                        </el-select>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 卡号:</span>
                        <el-input type="text"  class="query-input" size="small" placeholder="请输入" v-model="query.card" clearable></el-input>
                    </div>
                </div>
                <div class="orderManage-query-input query-input-between">  
                    <div class="flexX flexWrap">                          
                        <div class="query-input-item">
                            <span class="input-item-label"> 下单时间:</span>
                            <el-date-picker class="query-date" size="small" v-model="query.orderDate" clearable type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00','23:59:59']"></el-date-picker>
                        </div> 
                        <div class="query-input-item">
                            <span class="input-item-label"> 核销时间:</span>
                            <el-date-picker class="query-date" size="small" v-model="query.verificationDate" clearable type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00','23:59:59']"></el-date-picker>
                        </div>
                    </div> 
                    
                    <div class="query-input-item">
                        <el-button class="query-btn" type="primary" size="small" :disabled="query.loading" @click = "getData">查询</el-button>
                        <el-button class="query-btn cancel" plain size="small" :disabled="query.loading" @click="reset">重置</el-button>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card>
            <div class="orderManage-table-div">
                <div class="table-toolbar">
                    <div class="total-data-box">
                        <div class="total-data-item">总订单数 : {{table.statistics.total_order_count}}</div>
                        <div class="total-data-item">成功订单数 : {{table.statistics.success_order_count}}</div>
                        <div class="total-data-item">总金额 : ¥{{table.statistics.total_order_amount}}</div>
                        <div class="total-data-item">成功金额 : ¥{{table.statistics.total_success_amount}}</div>
                        <div class="total-data-item">成功率 : {{table.statistics.success_rate}}</div>
                    </div>
                    <div class="toolbar-right">                        
                        <el-button type="plan" icon="el-icon-refresh" size="small" @click="allList">刷新</el-button>
                    </div>
                </div>
                <el-table class="table-class"  :data="table.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    
                    <el-table-column prop="water_no" label="订单号" width="150px">
                        <template scope="scope">
                            <div class="c303133">{{scope.row.order_id}}</div>
                        </template>
                    </el-table-column>                    
                    
                    <el-table-column prop="" label="商户信息" min-width="117px"  v-if="$PayNameImg == 'lianmei' || $PayNameImg == 'default'">
                        <template scope="scope">
                            <div>
                                <div class="c303133">商户名：{{scope.row.business_name}}</div>
                                <div class="c909399">商户号：{{scope.row.business_no}}</div>
                            </div>
                        
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="产品" width="130px">
                        <template slot-scope="scope">
                            <div class="c303133 fw5">
                                <span>{{scope.row.product_name}}</span>
                                <span v-if="scope.row.product_name && scope.row.denomination_value">-</span>
                                <span v-if="scope.row.denomination_value">[</span>
                                <span>{{scope.row.denomination_value}}</span>
                                <span v-if="scope.row.denomination_value">]</span>
                            </div>
                            <div class="fs12 c909399"><span>编码：{{scope.row.product_code}}</span></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="game_account" label="游戏账号" width="150px"></el-table-column>
                    <el-table-column prop="denomination_value" label="订单面值" >
                        <template scope="scope">
                            <div class="" v-if="scope.row.denomination_value">¥{{scope.row.denomination_value}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="balance" label="核销状态" >
                        <template slot-scope="scope">
                            <div class="nowrap textCenter">
                                <span :style="{color:scope.row.card_status_color}">{{scope.row.card_status_text}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="卡密信息" min-width="117px" >
                        <template scope="scope">
                            <div v-if="scope.row.state==1">
                                <div class="c303133">{{scope.row.card_number}}</div>
                                <div class="c909399">{{scope.row.card_password}}</div>
                            </div>
                        
                        </template>
                    </el-table-column>
                   
                    <el-table-column prop="" label="时间" min-width="200px">
                        <template slot-scope="scope">
                            <div class="nowrap">
                                <div class="c303133"><span>下单：{{scope.row.add_time?scope.row.add_time:'无'}}</span></div>
                                <div class="c909399"><span>核销：{{scope.row.action_time?scope.row.action_time:'无'}}</span></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <div class="nowrap textCenter">
                                <el-button type="text" v-if="scope.row.state==2" @click="writeOff(scope.row)">核销</el-button>
                                <el-button class="c909399 write-off-log" type="text" v-if="scope.row.card_status == 1" @click="operationLogs(scope.row)">核销日志</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flexX pageBox flexEnd">
                    <el-pagination :disabled="query.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="query.pageSizesArr"
                        :page-size="query.pageSize" layout="total, sizes, prev, pager, next" :total="query.total"></el-pagination>
                </div>
            </div>
        </el-card>
        <div class="dialog-div">           
            <el-dialog custom-class="operationLogs-dialog-class" :top="dialog.top" :visible.sync="dialog.opeVisible" @close="closeOpe" width="46%" :close-on-click-modal="true" :show-close="false">
                <el-table class="table-class" max-height="50vh" :data="dialog.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    <el-table-column prop="" label="操作时间" >
                        <template slot-scope="scope">
                        <div class="nowrap">
                           <span>{{scope.row.add_time}}</span>
                        </div>
                    </template>
                    </el-table-column>
                    <el-table-column prop="operator" label="操作账户ID" ></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>                           
                </el-table>
            </el-dialog>
            <WriteOffDialog :item="dialog.item" :visible="dialog.visible" :loading="dialog.loading"  @close="close"  @ensure="ensure" :pwdError = "dialog.pwdError"></WriteOffDialog>
        </div>
    </div>
</template>

<script>
    import {
		Message
	} from 'element-ui'
    import WriteOffDialog from '@/components/writeOff/writeOffDialog.vue'
    export default {
        data() {
            return{
                query:{
                    loading:false,
                    order_id:'',
                    product_code:'',
                    denomination_value:'',
                    business_no:'',
                    game_account:'',

                    traderId:'',
                    email:'',
                    state:'',
                    card:'',
                    add_gold:'',
                    bagId:'',
                    orderDate:[],//下单日期
                    verificationDate:[],//核销日期
                    page:0,
                    pageSizesArr:[10,50,200,500],
                    total:0,
                    pageSize: 10,
                },
                table:{
                    tableData:[],
                    height:'200px',
                    lockArr:[],
                    unlockArr:[],
                    statistics:{},
                },
                dialog:{
                    top:"15vh",
                    visible:false,
                    opeVisible:false,//操作日志弹窗
                    loading:false,
                    form:{
                        card:'',
                        pwd:'',
                        note:'',
                        id:''
                    },
                    item:{

                    },
                    tableHeight:'200px',
                    tableData:[],
                    pwdError:''//卡密校验
                },
                options:{
                    productList:[],
                    faceValueList:[],
                },
                rules:{
                    card:[{ required: true, message: '卡号不能为空', trigger: 'blur' }],
                    pwd:[{ required: true, message: '卡密不能为空', trigger: 'blur' }],

                   
                }
            }
        },
        components:{
            WriteOffDialog
        },
        created() {
			this.query.orderDate = [ this.$util.timestampToTime(new Date().getTime(),true)+' 00:00:00', this.$util.timestampToTime(new Date().getTime(),true)+' 23:59:59'];
			this.query.verificationDate = [];            
            this.getFaceValueList();
            this.getProductList();
            this.allList();
		},
        methods: {
          //面值列表
          getFaceValueList(){
                this.$api.getFaceValueList({}).then(res=>{
                    if(res.status == 1){
                        this.options.faceValueList = res.data
                    }else{
                        Message.error(res.msg)
                    }
                })
            },
            //产品列表
            getProductList(){
                this.$api.getProductList({}).then(res=>{
                    if(res.status == 1){
                        this.options.productList = res.data
                    }else{
                        Message.error(res.msg)
                    }
                })
            },
              //计算表格高度
            getTableHeight(){
                this.$nextTick(() => {
                    let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
                    let queryBox = document.getElementsByClassName('orderManage-query')[0].offsetHeight;
                    let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
                    let documentHeight = document.documentElement.clientHeight
                    this.table.height = documentHeight - topNav - 20 - queryBox - 41 - pageBox - 20 - 70 +'px'
                }) 
              },
            ////计算窗口位置
            getDialogTop(className){
                this.$nextTick(() => {			
                    let documentHeight = document.documentElement.clientHeight
                    let dialogdiv =  document.getElementsByClassName(className)[0].offsetHeight
                    this.dialog.top =( documentHeight - dialogdiv) / 2 +'px'
                    console.log(documentHeight,'===',dialogdiv,'===',this.dialog.top)
                })
            },
            //查询按钮触发
            getData(){
                this.query.page = 1;
                this.query.total = 0;
                this.allList()
            },
            // 分页查询数据
            handleSizeChange(val){
                this.query.pageSize = val;
                this.query.page = 1
                this.query.total = 0
                this.allList()
            },
            handleCurrentChange(val){
                this.query.page = val
                this.allList()
            },
            // 订单列表查询接口
            allList(){
                this.getTableHeight();
                let data ={
                    "order_id": this.query.order_id,//  筛选项 订单编号
                    "product_code":this.query.product_code,//产品
                    "denomination_value":this.query.denomination_value,//面值
                    "card": this.query.card,//  筛选项 卡号
                    "startTime": this.query.orderDate ? this.query.orderDate[0] ? this.$util.timestampToTime(Date.parse(new Date(this.query.orderDate[0])), false) : '':'', // 下单开始时间
                    "endTime":this.query.orderDate ? this.query.orderDate[1] ? this.$util.timestampToTime(Date.parse(new Date(this.query.orderDate[1])), false) : '':'', // 下单结束时间
                    "startActionTime":this.query.verificationDate && this.query.verificationDate.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.query.verificationDate[0])), false) : '',//核销开始时间
                    "endActionTime":this.query.verificationDate && this.query.verificationDate.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.query.verificationDate[1])), false) : '',//核销结束时间
                    "size": this.query.pageSize,
                    "page": this.query.page,
                    'business_no':this.query.business_no,
                    'game_account':this.query.game_account,
                }
                this.query.loading = true;
                this.$api.allList(data).then(res=>{
                    this.query.loading = false;
                    if(res.status == 1){
                        this.table.tableData = res.data.data
                        this.table.statistics = res.data.statistics
                        this.query.total = res.data.total
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.query.loading = false;
                })
            },
            // 重置查询条件
            reset(){
                // this.query.orderDate = [];
                this.query.verificationDate = [];
                this.query.orderDate = [ this.$util.timestampToTime(new Date().getTime(),true)+' 00:00:00', this.$util.timestampToTime(new Date().getTime(),true)+' 23:59:59'];
			    // this.query.verificationDate = [this.$util.timestampToTime(new Date().getTime(),true)+' 00:00:00', this.$util.timestampToTime(new Date().getTime(),true)+' 23:59:59'];   
                this.query.state = ""
                this.getData()
            },
            //核销接口
            ensure(form,id){
                let data = {
                    "id": id,//  订单id
                    "card": form.card,//  卡号
                    "pwd": form.pwd,//  卡密
                    "note": form.note,//  备注                    
                }
                this.dialog.loading = true;
                this.$api.ensure(data).then(res=>{
                    if(res.status == 1){
                        this.dialog.visible = false;
                        this.allList();
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        });
                        this.close()
                    }else{
                        this.dialog.pwdError = res.msg;
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                    this.dialog.loading = false;
                }).catch(e=>{
                    console.log(e)
                    this.dialog.loading = false;
                })
            },
            //操作日志
            operationLogs(item){

                this.dialog.opeVisible = true;
                this.$nextTick(() => {	
                this.getDialogTop('operationLogs-dialog-class')
                })
               let data = {
                id:item.id
               }
                this.$api.getOrderOperatorLog(data).then(res=>{
                    if(res.status == 1){
                        this.dialog.tableData = res.data
                        this.$nextTick(() => {	
                            this.getDialogTop('operationLogs-dialog-class')
                        })
                    }
                })
            },
            //关闭操作日志
            closeOpe(){
                this.dialog.opeVisible = false;
                this.dialog.tableData=[]
            },
            close(){
                console.log('close')
                this.dialog.visible = false;
                this.dialog.pwdError ="";
                this.dialog.item = {}
            },
            //确认核销
            writeOff(row){
                this.dialog.visible = true;
                this.dialog.pwdError ="";
                this.dialog.item = row;
            },
        }
    }
</script>

<style lang="scss">
    @import "@/style/tablestyle.scss";
    .write-off-container{
        .dialog-div{
            .el-form-item__label{
                width: 90px !important;
            }
            .operationLogs-dialog-class{
                .el-dialog__header{
                    display: none;
                }
            }
            
        }
    }
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
.write-off-container{
    padding-top: 10px;
    padding-right: 10px;
    .orderManage-query{
        padding-left:10px;       
        .orderManage-query-input{
            display:flex;
            justify-content: flex-start;
            align-items:center;
            flex-wrap: wrap;
            &.query-input-between{
                justify-content: space-between;
            }
            .query-input-item{
                margin-bottom: 16px;
                margin-right:25px;
                display:flex;
                font-size:14px;
                align-items:center;
                .input-item-label{
                    white-space: nowrap;
                    margin-right: 10px;
                    color: #606266;
                }
                .query-select-shot{
                    width: 126px;
                }
                .query-date{
                    width: 340px;
                }
                .query-input{
                    width: 200px;
                    margin-left: 20px;
                }
                .query-input-area{
                    width: 300px;
                }
                
            }
        }
        .orderManage-query-btn{
            .query-btn{
                width: 80px;
                height: 30px;
            }
        }
    }
    .orderManage-table-div{
        // margin-top:41px;
        .table-toolbar{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            padding: 16px;
            background: #fff;
            border-bottom: 1px solid #ebeef5;
            .total-data-box{
                display: flex;
                gap: 20px;
                font-size: 14px;
                color: #3d3d3d;
            }
        }
        .write-off-log{
            &:hover{
                color:#c8c9cc;
            }
            &:focus{
                color:#c8c9cc;
            }
        }
        .pageBox{
            padding: 16px 20px;
            border-top: 1px solid #ebeef5;
            background-color: #fafcff;

        }
    }
    .dialog-div {
        .verification-dialog-class{
            .dialog-box{
                max-height:70vh !important;
                overflow-y:auto;
                .dialog-info-box{
                    .dialog-info-item{
                        display:flex;
                        justify-content: flex-start;
                        align-items:center;
                        margin-bottom: 14px;
                        .dialog-info-item-label{
                            // width: 80px;
                            white-space:nowrap;
                            // margin-right: 10px;
                        }
                        .dialog-info-item-value{
                            flex:1;
                        }
                    }
                }
                .dialog-form-box{
                    margin-top: 36px;
                    .dialog-div-input{
                        width: 200px;
                    }
                    .form-error-div{
                        padding-left:90px;
                    }
                }
            }
        }
    }
}
</style>